export namespace Preference {
    export const KEY = "preference";

    export enum Lab {
        DevMode = "Development Mode",
        PageFeedback = "PageFeedback",
        QuickChatAgent = "Quick Chat Agent",
        TextHighlightShare = "Text Highlight Share",
    }
    export class Value {
        userId: string;
        instanceId: string;
        labs: Set<Lab>;
    }
}
